import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";

export const reasonsApi = api
  .enhanceEndpoints({ addTagTypes: ["reasons"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      deleteReason: builder.mutation({
        query: ({ branchId, id }) => ({
          url: `branchs/${branchId}/reasons/${id}`,
          method: RequestMethod.DELETE,
        }),
        invalidatesTags: ["reasons"],
      }),
      updateReason: builder.mutation({
        query: ({ id, description, branchId, type }) => ({
          url: `branchs/${branchId}/reasons/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({
            id,
            description,
            branchId,
            type,
          }),
        }),
      }),
      createReason: builder.mutation({
        query: ({ description, branchId, type }) => ({
          url: `branchs/${branchId}/reasons`,
          method: RequestMethod.POST,
          body: camelToSnake({
            description,
            branchId,
            type,
          }),
        }),
        invalidatesTags: ["reasons"],
      }),
      reasons: builder.query({
        query: ({ branchId }) => ({
          url: `branchs/${branchId}/reasons`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
        providesTags: ["reasons"],
      }),
    }),
  });

export const {
  useReasonsQuery,
  useDeleteReasonMutation,
  useUpdateReasonMutation,
  useCreateReasonMutation,
} = reasonsApi;
